export const resolvePageTitle = (t, title) => {
  return title
    ? t('components.Page.title.specific', { title })
    : t('components.Page.title.generic');
};
